import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpUtilService } from 'src/app/services/http-util.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private logoCache: { [companyId: number]: string } = {};

  constructor(private http: HttpClient, private httpUtilService: HttpUtilService) { }

  // getCompanyLogo(companyId: number): Promise<Observable<HttpResponse<Object>>> {
  //   const self = this;
  //   const apiEndpoint = 'company/' + companyId + '/logo';
  //   return self.httpUtilService.invokeQuery('GET', null, apiEndpoint);
  // }
  clearCompanyLogoCache(companyId: number): void {
    // Remove from memory cache
      if (this.logoCache[companyId]) {
          delete this.logoCache[companyId];
      }

      // Remove from localStorage
      localStorage.removeItem(`companyLogo_${companyId}`);
  }

  getCompanyLogo(companyId: number): Observable<Blob> {
    let api_host = environment.apiUrl;
    const apiEndpoint = api_host + `company/${companyId}/logo`;

    // Check memory cache first
    if (this.logoCache[companyId]) {
      return of(this.dataURItoBlob(this.logoCache[companyId]));
    }

    // Check localStorage
    const cachedLogo = localStorage.getItem(`companyLogo_${companyId}`);
    if (cachedLogo) {
      this.logoCache[companyId] = cachedLogo; // Store in memory
      return of(this.dataURItoBlob(cachedLogo));
    }

    // Fetch from API, store in cache
    return this.http.get(apiEndpoint, { responseType: 'blob' }).pipe(
      tap(blob => {
        this.cacheBlob(companyId, blob);
      })
    );
  }

  async deleteCompanyLogo(companyId: number): Promise<Observable<HttpResponse<Boolean>>> {
    const self = this;
    const apiEndpoint = `company/${companyId}/logo`;

    return self.httpUtilService.invokeWithFormData('DELETE', null, apiEndpoint);
  }

  async deleteItemSkus(companyId: number, itemsToDelete: any[]):Promise<Observable<HttpResponse<Object>>> { 
    const self = this;
    const apiEndpoint = 'pharmacy/' + companyId + '/itemSkus';

    return self.httpUtilService.invokeWithFormData('DELETE', itemsToDelete, apiEndpoint);
  }


  private cacheBlob(companyId: number, blob: Blob) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result as string;
      this.logoCache[companyId] = dataUrl;
      localStorage.setItem(`companyLogo_${companyId}`, dataUrl); // ✅ Store base64 data URI in localStorage
    };
    reader.readAsDataURL(blob);
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
}
